import { BaseModel } from '../../../models/base-model'

import { MenuItem, PathNode } from './../'

export class PathConfiguration extends BaseModel {
  public rootMenuItem: MenuItem
  public rootPathNode: PathNode
  public experienceType: number
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/path-configuration/path-configuration.ts